/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_ClearInputs */

const en_chat_clear = /** @type {(inputs: Chat_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear chat history`)
};

const ar_chat_clear = /** @type {(inputs: Chat_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مسح سجل المحادثة`)
};

const bn_chat_clear = /** @type {(inputs: Chat_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`চ্যাটের হিস্ট্রি মুছুন`)
};

const de_chat_clear = /** @type {(inputs: Chat_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chatverlauf löschen`)
};

const es_chat_clear = /** @type {(inputs: Chat_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar historial de chat`)
};

const fr_chat_clear = /** @type {(inputs: Chat_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer l'historique des discussions`)
};

const pt_chat_clear = /** @type {(inputs: Chat_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar histórico de bate-papo`)
};

const zh_chat_clear = /** @type {(inputs: Chat_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清除聊天记录`)
};

const tr_chat_clear = /** @type {(inputs: Chat_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sohbet geçmişini temizle`)
};

const ru_chat_clear = /** @type {(inputs: Chat_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистить историю чата`)
};

const pl_chat_clear = /** @type {(inputs: Chat_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyczyść historię czatów`)
};

/**
* | output |
* | --- |
* | "Clear chat history" |
*
* @param {Chat_ClearInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const chat_clear = /** @type {((inputs?: Chat_ClearInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_ClearInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_chat_clear(inputs)
	if (locale === "bn") return bn_chat_clear(inputs)
	if (locale === "de") return de_chat_clear(inputs)
	if (locale === "es") return es_chat_clear(inputs)
	if (locale === "fr") return fr_chat_clear(inputs)
	if (locale === "pt") return pt_chat_clear(inputs)
	if (locale === "zh") return zh_chat_clear(inputs)
	if (locale === "tr") return tr_chat_clear(inputs)
	if (locale === "ru") return ru_chat_clear(inputs)
	if (locale === "pl") return pl_chat_clear(inputs)
	return en_chat_clear(inputs)
});